/**
 * Partnerbereich: "Meine Einschulungen"
 * Alle gebuchten Termine mit Status aus der Anfragen-Liste.
 * Stornieren ist bis zum Terminbeginn moeglich; Verschieben = stornieren und neu buchen.
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';
import { partnerAPI } from '../../services/api';
import './Partner.css';

const STATUS_KLASSE = {
  'Neu gebucht': 'neu',
  'In Arbeit': 'arbeit',
  'Mitglied ✓': 'mitglied',
  'Kunde ✓': 'mitglied',
  'Kein Abschluss': 'aus',
  'Storniert': 'aus'
};

const PartnerEinschulungen = () => {
  const [liste, setListe] = useState(null);
  const [fehler, setFehler] = useState('');
  const [storniert, setStorniert] = useState(null);

  const laden = () => {
    partnerAPI.getEinschulungen()
      .then(res => setListe(res.data))
      .catch(err => setFehler(err.response?.data?.error || 'Einschulungen konnten nicht geladen werden'));
  };

  useEffect(laden, []);

  const stornieren = async (e) => {
    const datum = format(parseISO(e.datum), 'EEEE, d. MMMM', { locale: de });
    if (!window.confirm(`Einschulung mit ${e.kunde} am ${datum} um ${e.start} Uhr wirklich stornieren?\n\nStudio und Kunde bekommen eine Mail.`)) return;
    setFehler('');
    try {
      await partnerAPI.stornieren(e.id);
      setStorniert(e.kunde);
      laden();
    } catch (err) {
      setFehler(err.response?.data?.error || 'Stornieren hat nicht geklappt');
    }
  };

  return (
    <div className="partner-page">
      <div className="pt-titelzeile">
        <h1 className="pt-titel">Meine Einschulungen</h1>
        <Link to="/partner" className="pt-btn pt-btn-primaer">+ Termin buchen</Link>
      </div>

      {storniert && (
        <div className="pt-erfolg">
          Einschulung mit {storniert} storniert. Zum Verschieben einfach einen neuen Termin buchen.
        </div>
      )}
      {fehler && <div className="pt-fehler">{fehler}</div>}

      {liste === null && !fehler && <div className="pt-laedt">Lade…</div>}

      {liste && liste.length === 0 && (
        <div className="pt-card pt-leer">
          <p>Du hast noch keine Einschulungen gebucht.</p>
          <Link to="/partner" className="pt-btn pt-btn-primaer">Ersten Termin buchen</Link>
        </div>
      )}

      {liste && liste.length > 0 && (
        <div className="pt-card pt-tabelle-wrap">
          <table className="pt-tabelle">
            <thead>
              <tr>
                <th>Datum</th>
                <th>Studio</th>
                <th>Kunde</th>
                <th>E-Mail</th>
                <th>Status</th>
                <th aria-label="Aktion" />
              </tr>
            </thead>
            <tbody>
              {liste.map(e => (
                <tr key={e.id} className={e.storniert ? 'storniert' : ''}>
                  <td data-label="Datum">
                    <strong>{format(parseISO(e.datum), 'EEE, d.M.yyyy', { locale: de })}</strong>
                    <br /><span className="pt-muted">{e.start}–{e.ende} Uhr</span>
                  </td>
                  <td data-label="Studio">{e.studio}</td>
                  <td data-label="Kunde">
                    {e.kunde}
                    <br /><span className="pt-muted">{e.einschulungDurch === 'franz' ? 'Einschulung durch FRANZ' : 'Einschulung durch dich'}</span>
                  </td>
                  <td data-label="E-Mail" className="pt-umbruch">{e.email}</td>
                  <td data-label="Status">
                    <span className={`pt-status ${STATUS_KLASSE[e.status] || 'neu'}`}>{e.status}</span>
                  </td>
                  <td className="pt-zelle-aktion">
                    {e.stornierbar && (
                      <button type="button" className="pt-link-btn" onClick={() => stornieren(e)}>Stornieren</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PartnerEinschulungen;
